import React, { FC } from "react";
import {
  Box,
  Flex,
  Stack,
  Text,
  HStack,
  Button,
  useTheme,
} from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import Icon from "@modules/Icon";
import { HeaderFlagLogo } from "../style";
import ResponsiveContainer from "./ResponsiveContainer";

interface IProps {}
const SubNavigation: FC<IProps> = () => {
  const theme = useTheme();
  return (
    <Box bg={"grey100"}>
      <ResponsiveContainer px={4}>
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <Box />

          <Flex alignItems={"center"}>
            <Stack direction={"row"} spacing={7}>
              <GatsbyLink to={"/our-blog"}>
                <Text
                  pr={"0"}
                  py={2}
                  textStyle={"hind_s"}
                  fontWeight={"600"}
                  color={"misc750"}
                >
                  Blog
                </Text>
              </GatsbyLink>

              <HStack ml="8">
                <HeaderFlagLogo>
                  <Icon name="flag" />
                </HeaderFlagLogo>

                <Text textStyle={"hind_s"} fontWeight={"600"} color={"misc750"}>
                  Built in the USA
                </Text>
              </HStack>

              <Stack display={{ customLg: "none", base: "flex" }}>
                <GatsbyLink to="/request-a-demo">
                  <Button variant="primary">Request a Demo</Button>
                </GatsbyLink>
              </Stack>
            </Stack>
          </Flex>
        </Flex>
      </ResponsiveContainer>
    </Box>
  );
};

export default SubNavigation;
